import {
  RawWarningResponse,
  SaveWarningParams,
  DeleteWarningParams,
  Warning,
} from 'helper/home';
import { DynamicContent } from 'types/Home/getDynamicContent';
import { transformGetDynamicContent } from 'helper/Home';
import { transformListWarnings } from 'helper/Home/warnings';
import baseApi, { GenericResponse } from './base';

export type ListWarningsResponse = GenericResponse<RawWarningResponse[]>;

export const homeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listWarnings: build.query<Warning[], void>({
      query: () => 'avisos-list',
      transformResponse: transformListWarnings,
    }),
    saveWarning: build.mutation<any, SaveWarningParams>({
      query: ({
        id,
        title,
        message,
        expirationTime,
      }) => ({
        url: 'avisos-save',
        method: 'POST',
        body: {
          id,
          mensagem: message,
          titulo: title,
          tempo_expiracao: expirationTime,
        },
      }),
    }),
    deleteWarning: build.mutation<any, DeleteWarningParams>({
      query: ({ id }) => ({
        url: 'avisos-delete',
        method: 'POST',
        body: { id },
      }),
    }),
    getDynamicContent: build.query<DynamicContent, void>({
      query: () => ({
        url: 'produtos/home/carrossel/list-images',
        method: 'GET',
      }),
      transformResponse: transformGetDynamicContent,
    }),
  }),
});

export const {
  useListWarningsQuery,
  useSaveWarningMutation,
  useDeleteWarningMutation,
  useGetDynamicContentQuery,
} = homeApi;
